<template>
  <main>
    <hirer-profile v-if="!isViewer" />
    <profile-layout v-else>
      <template slot="sidebar">
        <sidebar-modal :title="sidebarTitle"
          :active.sync="isSidebarActive"
          :button="sidebarButton"
          :loading="sidebarLoading"
          :destructive="sidebarDestructiveButton"
          >
          <component v-bind:is="sidebarComponent"></component>
        </sidebar-modal>
      </template>
      <template slot="left">
        <div class="section">
          <user-detail-card :isCompanyLink="true" :brandImageUrl="brandPictureUrl" :coverImageUrl="coverImageUrl" :company="company" :hirer="true" :editable="false" :showDropdown="false" />
        </div>
        <div class="section">
          <external-profile-section @add="onViewmoreProfiles" :isViewer="isViewer"></external-profile-section>
        </div>
        <div class="section" v-if="company">
          <open-jobs-section :company="company" :isViewer="isViewer" />
        </div>
      </template>
      <template slot="right">
          <div class="referrer-card is-fixed">
            <hirer-action-card :company="company" :isViewer="isViewer" />
          </div>
      </template>
    </profile-layout>
  </main>
</template>

<script>
import ProfileLayout from '@/templates/profile-layout'
import UserDetailCard from '@/components/profile/user-details-card'
import OpenJobsSection from '../components/profile/hirer/open-jobs-section'
import HirerActionCard from '../components/profile/hirer/hirer-action-card'
import SidebarModal from '@/components/sidebar-modal'
import ExternalProfileList from '@/components/profile/profiles/profile-list'
import ExternalProfileSection from '@/components/profile/profiles/profile-section'
import HirerProfile from '@/pages/profiles/hirer-profile'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      sidebarTitle: this.$t('jobs.socialProfiles'),
      isSidebarActive: false,
      sidebarComponent: 'ExternalProfileList',
      sidebarButton: null,
      sidebarLoading: false,
      sidebarDestructiveButton: null
    }
  },
  components: {
    ProfileLayout,
    UserDetailCard,
    OpenJobsSection,
    HirerActionCard,
    SidebarModal,
    ExternalProfileSection,
    ExternalProfileList,
    HirerProfile
  },
  computed: {
    ...mapGetters('HirerProfile', ['company', 'coverImageUrl', 'brandPictureUrl']),
    ...mapGetters('users', ['coverPictureUrl', 'user']),
    getId () {
      return this.$route.params.id
    },
    profiles () {
      return []
    },
    isViewer () {
      if (this.user) {
        // returning false if the profile is viewed by company itself.
        return !(this.getId === this.user.companyId)
      }
      return true
    },
    socialProfiles () {
      return this.profiles.filter((p) => {
        return p.profileValue !== null && p.profileValue !== ''
      })
    }
  },
  methods: {
    onViewmoreProfiles () {
      this.isSidebarActive = true
    }
  },
  async mounted () {
    if (!this.getId || !this.isViewer) return
    this.$store.dispatch('HirerProfile/getCompanyDetail', this.getId)
    this.$store.dispatch('HirerProfile/getSocialProfiles', this.getId)
  }
}
</script>
<style lang="scss" scoped>

div.section:first-child {
  padding: 0;
}

div.section {
  padding: 0;
}

div.section:not(:first-child) > div {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-top: 2.5rem;
}

.card {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/hirer-page.vue